var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcnLocation = function SvgIcnLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 0a5.596 5.596 0 0 0-5.6 5.6C2.5 9.8 8.1 16 8.1 16s5.6-6.2 5.6-10.4c0-3.096-2.504-5.6-5.6-5.6Zm0 7.6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: "#fff"
  })));
};

export { SvgIcnLocation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMSAwQzUuMDA0IDAgMi41IDIuNTA0IDIuNSA1LjZDMi41IDkuOCA4LjEgMTYgOC4xIDE2QzguMSAxNiAxMy43IDkuOCAxMy43IDUuNkMxMy43IDIuNTA0IDExLjE5NiAwIDguMSAwWk04LjEgNy42QzcuNTY5NTcgNy42IDcuMDYwODYgNy4zODkyOSA2LjY4NTc5IDcuMDE0MjFDNi4zMTA3MSA2LjYzOTE0IDYuMSA2LjEzMDQzIDYuMSA1LjZDNi4xIDUuMDY5NTcgNi4zMTA3MSA0LjU2MDg2IDYuNjg1NzkgNC4xODU3OUM3LjA2MDg2IDMuODEwNzEgNy41Njk1NyAzLjYgOC4xIDMuNkM4LjYzMDQzIDMuNiA5LjEzOTE0IDMuODEwNzEgOS41MTQyMSA0LjE4NTc5QzkuODg5MjkgNC41NjA4NiAxMC4xIDUuMDY5NTcgMTAuMSA1LjZDMTAuMSA2LjEzMDQzIDkuODg5MjkgNi42MzkxNCA5LjUxNDIxIDcuMDE0MjFDOS4xMzkxNCA3LjM4OTI5IDguNjMwNDMgNy42IDguMSA3LjZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";